import {makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
    scoreDiv : {
        backgroundColor: 'dodgerblue',
        padding: '10px',
        margin: '10px auto',
        maxWidth: '400px',
        borderRadius: '5px'
    }
}));